import * as Yup from "yup";

export const ProfileFormValidation = () => Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  lastNamePrefix: Yup.string(),
})